import React, { Component, Fragment } from 'react';
import {Intercom, show, hide, onUnreadCountChange, onHide, onShow} from '@intercom/messenger-js-sdk';

class IntercomMessenger extends Component {
  render() {
    const { opened } = this.props;
    if (!opened) {
      return null;
    }
    return <Fragment />;
  }

  componentDidMount() {
    Intercom({
        app_id: this.props.appId,
        z_index: 100000,
        horizontal_padding: 40,
        vertical_padding: 40,        
        user_id: this.props.user ? this.props.user._id: undefined, 
        name: this.props.user ? this.props.user.name: undefined,
        email: this.props.user ? this.props.user.email: undefined, 
        created_at: this.props.user ? this.props.user.createdAt: undefined,       
    });
    this.setupIntercomEvents();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.opened !== this.props.opened) {
      this.handleVisibilityChange();
    }
  }

  handleVisibilityChange = () => {
    const { opened } = this.props;        
    opened ? show():  hide();            
  }


  setupIntercomEvents = () => {
    const self = this;
    onShow(function() {      
      self.props.onStateUpdate({
        isVisibleChatIntercom: true,
        isVisibleFab: false,
      })
    });

    onHide(function() {
      self.props.onStateUpdate({
        isVisibleChatIntercom: false,
        isVisibleFab: true,
      });
    });

    onUnreadCountChange(function(unreadCount) {
      if (unreadCount > 0) {
        self.props.onStateUpdate({
          isVisibleChatIntercom: true,
          isVisibleFab: false,
        });
        show(); // Show the widget on new messages
      }
    });    
  };
 
}

export default IntercomMessenger;